import { render, staticRenderFns } from "./OrganizedGame.vue?vue&type=template&id=46b093ca&"
import script from "./OrganizedGame.vue?vue&type=script&lang=ts&"
export * from "./OrganizedGame.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports